const form = {
  formId: "new-issue-form",
  formField: {
    name: {
      name: "name",
      label: "اسم المعوق",
      type: "text",
      errorMsg: "اسم المعوق مطلوب.",
    },
    description: {
      name: "description",
      label: "الوصف",
      type: "text",
      errorMsg: "الوصف مطلوب.",
    },
    ResponsibilityText: {
      name: "responsibilityText",
      label: "المسؤولية",
      type: "text",
      errorMsg: "المسؤولية مطلوبة.",
    },
    SolutionDescription: {
      name: "solutionDescription",
      label: "الحل",
      type: "text",
      errorMsg: "الحل مطلوب.",
    },

    startDate: {
      name: "startDate",
      label: "تاريخ البدء",
      type: "date",
      errorMsg: "تاريخ البدء مطلوب.",
    },
    endDate: {
      name: "endDate",
      label: "تاريخ الانتهاء",
      type: "date",
      errorMsg: "تاريخ الانتهاء مطلوب.",
    },
    priority: {
      name: "priorityId",
      label: "الاولوية",
      type: "number",
      errorMsg: " الاولوية مطلوب.",
    },
    Status: {
      name: "statusId",
      label: "الحالة",
      type: "number",
      errorMsg: "الحالة مطلوبة.",
    },
    projectId: {
      name: "projectId",
      label: "رقم المشروع",
      type: "text",
      errorMsg: "رقم المشروع مطلوب.",
    },
  },
};

export default form;
